import { isScrollingUp } from './functions.js'

const header = document.getElementById('header')
const sticky = document.querySelectorAll('.sticky')
const filters = document.getElementById('all-filters')

window.onscroll = function () {
  onScroll()
}

function onScroll() {
  if (filters) {
    return
  }

  if (isScrollingUp() && window.scrollY > 0) {
    header.setAttribute('data-fixed', '')
    if (sticky) {
      sticky.forEach((element) => {
        element.setAttribute('data-fixed', '')
      })
    }
  } else {
    header.removeAttribute('data-fixed')
    if (sticky) {
      sticky.forEach((element) => {
        element.removeAttribute('data-fixed')
      })
    }
  }
}
